//CHID - 1   UshaRani.m   21 / 01 / 2020   standByMD-1969: Add Age Risk Factor when moving from Demographics to Location
import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../../features/utils";
import { genderConst } from "../../../server/triage/constants";

export async function AddAgeRiskFactor({ state, actions }) {
    const { triageRequest } = state
    const { sessionId } = triageRequest
    const encounterToken = localStorage.getItem('token')
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const data = {
        identifier: sessionId,
        token: encounterToken,
        telemedicineDeclinedId: 0,
        comment: '',
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token
    }
    await actions.sendTriageRequest({ action: 'AgeRiskFactorLog', data })
}
export async function UpdateRiskFactors({ state, actions }) {
    const { triageRequest } = state
    const { sessionId, pregnant, selectChildBirth, gender } = triageRequest
    if (!state.isTravelAid2) {
        var recentPhysicalVal = await actions.GetRecentPhysicalInjuryRiskFactor({
            actions,
        });

        const encounterToken = localStorage.getItem('token')
        const presentRiskFactors = []
        const absentRiskFactors = []
        var jwtAccess_Token = generateJsonWebToken()
        var access_Token = checkAndGetSessionStorageValue("accessToken")
        if (gender == "F") {
            { pregnant === true ? presentRiskFactors.push('p_42') : absentRiskFactors.push('p_42') }
            { selectChildBirth === "Yes" ? presentRiskFactors.push('p_55') : absentRiskFactors.push('p_55') }
        }

        { triageRequest.data.selectRecentPhysicalInjury === "Yes" ? presentRiskFactors.push(recentPhysicalVal.id) : absentRiskFactors.push(recentPhysicalVal.id) }
        const data = {
            identifier: sessionId,
            token: encounterToken,
            presentRiskFactors,
            absentRiskFactors,
            jwtAccessToken: jwtAccess_Token,
            accessToken: access_Token
        }
        await actions.sendTriageRequest({ action: 'UpdateRiskFactorsLog', data })
    }
}